export default __webpack_public_path__ + "static/lightning_w.fa4e0fdf52fc0cbe651877a969315f4a.svg";